/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

modal.js - a base modal class


*/

class Modal {
  constructor(input) {
    this.data = input;
    this.closeButton = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="3 3 16 16" width="25" height="25">
			<g transform="matrix(2 0 0 2-11-2071.72)">
				<path class="outer" transform="translate(7 1037.36)" d="m4 0c-2.216 0-4 1.784-4 4 0 2.216 1.784 4 4 4 2.216 0 4-1.784 4-4 0-2.216-1.784-4-4-4" fill="#ccc"/>
				<path d="m11.906 1041.46l.99-.99c.063-.062.094-.139.094-.229 0-.09-.031-.166-.094-.229l-.458-.458c-.063-.062-.139-.094-.229-.094-.09 0-.166.031-.229.094l-.99.99-.99-.99c-.063-.062-.139-.094-.229-.094-.09 0-.166.031-.229.094l-.458.458c-.063.063-.094.139-.094.229 0 .09.031.166.094.229l.99.99-.99.99c-.063.062-.094.139-.094.229 0 .09.031.166.094.229l.458.458c.063.063.139.094.229.094.09 0 .166-.031.229-.094l.99-.99.99.99c.063.063.139.094.229.094.09 0 .166-.031.229-.094l.458-.458c.063-.062.094-.139.094-.229 0-.09-.031-.166-.094-.229l-.99-.99" fill="#fff"/>
			</g>
		</svg>`;
  }

  interactiveElements() {
    return `
			<div class="modal-buttons">
				<button id="${this.data.id}-button" class="button">
					${this.data.buttonText}
				</button>
				<button class="button cancel">Cancel</button>
				<br />
			</div>
		`;
  }

  modalElement() {
    if (!this.data.id) {
      return console.warn('No DOM ID specified.');
    } else {
      return `
				<div id="${this.data.id}" 
					class="modalDialog" 
					role="dialog" 
					aria-labelledby="${this.data.id}-title" 
					aria-describedby="${this.data.id}-desc"
				>
					<div class="modal">	
						<a title="Close" class="close cancel">
							${this.closeButton}
						</a>
						<h2 id="${this.data.id}-title">${this.data.title}</h2>
						<p id="${this.data.id}-desc">${this.data.content}</p>
						${this.interactiveElements()}
					</div>
				</div>
			`;
    }
  }

  getModalDOMElement() {
    return document.getElementById(this.data.id);
  }

  handleModalEvent(event, modal) {
    event.preventDefault();
    this.data.clickHandler();
    modal.classList.remove('visible');
  }

  closeModal(closers) {
    for (let button of closers) {
      button.addEventListener('click', () => {
        let modal = this.getModalDOMElement();
        modal.classList.remove('visible');
      });
    }
  }

  addModal() {
    let container = document.getElementById('content');
    container.insertAdjacentHTML('afterbegin', this.modalElement());

    let modal = this.getModalDOMElement();
    let closeButton = modal.querySelector('.close.cancel');
    let cancelButton = modal.querySelector('.button.cancel');
    let mainButton = document.getElementById(`${this.data.id}-button`);

    mainButton.addEventListener('click', (event) => {
      this.handleModalEvent(event, modal);
    });

    this.closeModal([closeButton, cancelButton]);
  }

  makeVisible() {
    document.getElementById(this.data.id).classList.add('visible');
  }

  makeInvisible() {
    document.getElementById(this.data.id).classList.remove('visible');
  }
}
